<!--
  Component: Log Setting

  Functionality:
  - Displays a tabbed interface for managing log settings.
  - Two tabs available:
      1. "DB Log Setting": Allows toggling status of different database log types.
      2. "API Log Setting": Allows toggling status of different API log types.
  - A dropdown labeled "Services" appears only when the "API Log Setting" tab is active (selectedTabIndex != 0).
      - This is controlled using [ngClass]="{ 'visibility-hidden': selectedTabIndex == 0 }" to hide the dropdown on the "DB Log Setting" tab.
      - The selected service can be changed via this dropdown and is handled by onServiceChange($event).
  - Each tab contains a custom data table component (app-admin-data-table) that displays log types.
      - DB tab uses event (logStatusToggled) to trigger updateDbLogStatus($event).
      - API tab uses event (toggleStatus) to trigger updateApiLogStatus($event).
  - A loading spinner (ngx-loading) is displayed during data fetching or updates when 'loader' is true.

  Notes: 
  - The layout uses Bootstrap-like utility classes for spacing and alignment.
  - The tableClass 'brand-table-wrapper' is applied for consistent styling of both tables.
  - isNotShowing input on app-admin-data-table might be used for conditional UI rendering or internal logic.
-->

<div class="container-wrapper padding-medium"> 
    <div class="d-flex justify-content-between align-items-center padding-top-medium padding-bottom-medium">
        <div class="header-title-section">
            <div class="title-wrapper d-flex justify-content-start align-items-center">
                <h3 class="page-title">Log Setting</h3>
                <app-admin-selection-dropdown
                    [ngClass]="{ 'visibility-hidden': selectedTabIndex == 0 }"
                    class="service-drop-down"
                    [label]="'Services'"
                    [options]="servicesOptions"
                    [value]="selectedService"
                    (selectionChangecustom)="onServiceChange($event)"
                >
                </app-admin-selection-dropdown>
            </div>
        </div>
    </div>
    <mat-tab-group (selectedIndexChange)="selectedTabIndex = $event">
        <mat-tab label="DB Log Setting">
            <div class="">
                <div class="content-section">
                    <app-admin-data-table 
                        [columns]="tableColumn"
                        [data]="dblogTypeList"
                        [tableClass]="'brand-table-wrapper'"
                        (toggleStatus)="updateDbLogStatus($event)"
                        [isNotShowing]="true">
                    </app-admin-data-table>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="API Log Setting"  (selectedTabChange)="onServiceChange($event)">
            <div class="">
                <div class="content-section">
                    <app-admin-data-table
                        [columns]="tableColumn"
                        [data]="apilogTypeList"
                        [tableClass]="'brand-table-wrapper'"
                        (toggleStatus)="updateApiLogStatus($event)"
                        [isNotShowing]="true">
                    </app-admin-data-table>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <ngx-loading [show]="loader" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>
</div>